
import { defineComponent, reactive, ref, watch } from "vue";
import {
  DownOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from "@ant-design/icons-vue";
import XDialog from "@/components/XDialog.vue";
import { loginOut, resetPassword, resetFinancialPassword } from "@/api/api";
import { useRouter } from "vue-router";
import { removeToken } from "@/utils/auth";
import { getUserInfo } from "@/utils/auth";
import { message } from "ant-design-vue";

/** 财务密码：6 位纯数字 */
const FINANCIAL_PIN_PATTERN = /^\d{6}$/;

interface FormState {
  account: string;
  password: string;
  oldPassword: string;
}

export default defineComponent({
  components: {
    DownOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    XDialog,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const formState = reactive<FormState>({
      account: "",
      password: "",
      oldPassword: "",
    });
    const dialogVisible = ref();
    const router = useRouter();
    const ccollapsed = ref(false);
    const userName = ref(localStorage.getItem("USERNAME"));
    const isAdminUser = ref(getUserInfo()?.roleType === 0);
    const isFinancialPassword = ref(false);
    const dialogTitle = ref("修改密码");
    const financialPinPatternRule = {
      pattern: FINANCIAL_PIN_PATTERN,
      message: "财务密码须为6位纯数字",
    };
    const financialPinOldRules = [
      { required: true, message: "请输入旧密码!" },
      financialPinPatternRule,
    ];
    const financialPinNewRules = [
      { required: true, message: "请输入新密码!" },
      financialPinPatternRule,
    ];
    const editPassword = () => {
      isFinancialPassword.value = false;
      dialogTitle.value = "修改密码";
      formState.account = userName.value;
      dialogVisible.value = true;
    };
    const editFinancialPassword = () => {
      isFinancialPassword.value = true;
      dialogTitle.value = "财务修改密码";
      formState.account = userName.value;
      dialogVisible.value = true;
    };
    watch(
      () => props.collapsed,
      (newVal, oldVal) => {
        ccollapsed.value = newVal;
      },
      { immediate: true }
    );
    const loginOutClick = () => {
      loginOut({}).then((res) => {
        router.replace("/");
        removeToken();
      });
    };
    const ccollapsedClick = () => {
      ccollapsed.value = !ccollapsed.value;
      ctx.emit("collapsedClick", ccollapsed.value);
    };
    const confirm = () => {
      if (isFinancialPassword.value) {
        if (
          !FINANCIAL_PIN_PATTERN.test(formState.oldPassword) ||
          !FINANCIAL_PIN_PATTERN.test(formState.password)
        ) {
          message.warning("财务密码须为6位纯数字");
          return;
        }
      }
      const requestApi = isFinancialPassword.value
        ? resetFinancialPassword
        : resetPassword;
      const payload = isFinancialPassword.value
        ? {
            oldPassword: formState.oldPassword,
            password: formState.password,
          }
        : formState;
      requestApi(payload).then((res) => {
        if (res.code === "200") {
          message.success("修改成功");
          router.replace("/login");
        }
      });
    };
    return {
      dialogVisible,
      ccollapsed,
      formState,
      userName,
      isAdminUser,
      dialogTitle,
      isFinancialPassword,
      financialPinOldRules,
      financialPinNewRules,
      editPassword,
      editFinancialPassword,
      loginOutClick,
      confirm,
      ccollapsedClick,
    };
  },
});
